import { render, staticRenderFns } from "./library-search-results.vue?vue&type=template&id=56d1bd84&scoped=true"
import script from "./library-search-results.vue?vue&type=script&setup=true&lang=js"
export * from "./library-search-results.vue?vue&type=script&setup=true&lang=js"
import style0 from "./library-search-results.vue?vue&type=style&index=0&id=56d1bd84&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56d1bd84",
  null
  
)

export default component.exports